import { render, staticRenderFns } from "./ObligadoSolidario.vue?vue&type=template&id=f0ae9990&scoped=true&lang=html&"
import script from "./ObligadoSolidario.vue?vue&type=script&lang=js&"
export * from "./ObligadoSolidario.vue?vue&type=script&lang=js&"
import style0 from "./ObligadoSolidario.vue?vue&type=style&index=0&id=f0ae9990&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ae9990",
  null
  
)

export default component.exports